import { Component, OnInit, Input } from '@angular/core';
import { AccountTypes } from '../../models/AccountTypes';
import { AuthenticationResult } from '../../models/authentication-result';
import { Navigation } from '../../models/navigation';
import { UiStateStore } from '../../store/ui-state-store.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
@Input() headerCSS: string;
@Input() displayLogo: boolean = true;
@Input() displaySignIn: boolean = true;

  user: AuthenticationResult;
  navigations: Navigation[] = [];

  constructor(private uiState: UiStateStore) { }

  ngOnInit() {
    this.uiState.authenticatedUser.subscribe(user => {
      this.user = user;
      this.navigations = this.user && this.user.accountType == AccountTypes.Candidate ? Navigation.getCandidateNavigations() : Navigation.getEmployerNavigations();
    });
  }

}
